const CryptoJS = require('crypto-js');

function createKey(key) {
  // CryptoJS 형식의 키 생성
  return CryptoJS.enc.Utf8.parse(key.padEnd(16, '\0').slice(0, 16));
}

function encrypt(textToEncrypt, key) {
  try {
    const keyObj = createKey(key);
    const encrypted = CryptoJS.AES.encrypt(textToEncrypt, keyObj, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: keyObj // 동일한 키를 IV로 사용
    });
    return encrypted.toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
}

function decrypt(textToDecrypt, key) {
  try {
    const keyObj = createKey(key);
    const decrypted = CryptoJS.AES.decrypt(textToDecrypt, keyObj, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: keyObj // 동일한 키를 IV로 사용
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}

// 사용 예시
const key = 'ANTS';
const encryptedData = encrypt('Hello, World!', key);
const decryptedData = decrypt(encryptedData, key);

//console.log('Encrypted:', encryptedData);
//console.log('Decrypted:', decryptedData);

module.exports = { encrypt, decrypt };